import Cookies from 'js-cookie';
import { ESTADOS_VIAJE } from '@/constants/viajeConstants';

export function isViajeDisponible(viaje) {
  if (!viaje) return false;
  return viaje.estado === ESTADOS_VIAJE.PUBLICADO || viaje.estado === ESTADOS_VIAJE.PAGADO;
}

export function isViajeBorrador(viaje) {
  return viaje?.estado === ESTADOS_VIAJE.EN_EDICION;
}

export function isViajePublicadoPausado(viaje) {
  if (!viaje) return false;
  return isViajeDisponible(viaje) && !!viaje.paused;
}

export function isViajeAccesibleOnlyInPreview(viaje) {
  if (!viaje) return false;
  return !isViajeDisponible(viaje) || !!viaje.paused;
}

export function isViajeActivo(viaje) {
  if (!viaje) return false;
  return (
    viaje.estado === ESTADOS_VIAJE.PUBLICADO ||
    viaje.estado === ESTADOS_VIAJE.PAGADO ||
    viaje.estado === ESTADOS_VIAJE.CERRADO
  );
}

export function isViajePrevisualizacion(routeQuery = {}) {
  return !!routeQuery.codigoPrevisualizacion;
}

export function getViajeApiParamsFromRoute(route, codigoPrevisualizacionProp = null) {
  const query = route?.query ?? {};
  return {
    codigoViaje: query.codigo || null,
    codigoPrevisualizacion: query.codigoPrevisualizacion || codigoPrevisualizacionProp || null,
  };
}

export function canReservarViaje(viaje) {
  if (!viaje) return false;
  return !isViajeAccesibleOnlyInPreview(viaje);
}

export function buildViajeRouteQuery(query = {}) {
  const result = {};
  if (query.codigo) result.codigo = query.codigo;
  if (query.grupo) result.grupo = query.grupo;
  if (query.codigoPrevisualizacion) result.codigoPrevisualizacion = query.codigoPrevisualizacion;

  const comercialId = query.comercialId || Cookies.get('comercialId');
  if (comercialId) result.comercialId = comercialId;

  return result;
}

export function shouldShowPreviewBanner(viaje, routeQuery = {}) {
  return isViajePrevisualizacion(routeQuery) && isViajeAccesibleOnlyInPreview(viaje);
}

export function getPreviewBannerMessageKey(viaje, routeQuery = {}) {
  if (isViajeBorrador(viaje) && !isViajePrevisualizacion(routeQuery)) {
    return 'general.previewBanner';
  }
  return 'general.previewModeBanner';
}

export function canMostrarBotonReservarLanding(viaje, routeQuery = {}) {
  return shouldShowPreviewBanner(viaje, routeQuery) || !isViajeAccesibleOnlyInPreview(viaje);
}
